import { useSelector } from 'react-redux';
import { useFeatureFlags } from '@client/contexts/FeatureFlagsContext';
import { selectSession, selectClientProfiles, selectMaybeClient } from '@client/model/selectors';
import { SessionType } from '@shared';

import { PageFn } from '@client/Router';
import { OnboardingOverview, OnboardingResultsAreIn } from '@client/pages';

export function useOnboardingEntryPage(): PageFn<{ clientId: string }> {
  const { flags } = useFeatureFlags();
  const session = useSelector(selectSession);
  
  let advisor = null;
  if (session.sessionType === SessionType.client) {
    return OnboardingResultsAreIn;
  } else if (session.sessionType === SessionType.advisor || session.sessionType === SessionType.wizard) {
    advisor = session.advisor;
  }

  const overviewSlideDefault = advisor?.defaultClientOnboardingOverviewSlide ?? true;
  const showOverviewSlide = flags.overviewSlide && overviewSlideDefault;

  return showOverviewSlide ? OnboardingOverview : OnboardingResultsAreIn;
}
